export default __webpack_public_path__ + "static/media/glass_jar_book_box_mundane.4e790a65.jpg";